export const SERVER_URL = 'https://job-server.net';

export const GOOGLE_MAP_KEY = 'AIzaSyD3uhokT0li-ms20myh_Dyi7ALNSQkSm-E';// 'AIzaSyD3uhokT0li-ms20myh_Dyi7ALNSQkSm-E';
